import { ReactElement } from "react";
import "./index.css";
import { useNavigate } from "react-router-dom";

interface IProps {
  index: number;
  title: string;
  step: string; //ступень
  totalLesson: number; //progressbar всего
  complitedLesson: number; //пройдено
  lockedSection: boolean; //false-закрыт true-открыт
  gold: boolean;
  pearl: boolean;
  preivSection: boolean;
}

export function LessonWidget(props: IProps): ReactElement {
  const progres = Math.floor((props.complitedLesson * 100) / props.totalLesson);
  const nav = useNavigate();

  let mainClass = "mainPage_lessonWisdom_Pad-Item";
  if (!props.lockedSection) {
    mainClass = mainClass + " disebled";
  }

  let section = "";
  if (props.lockedSection) {
    section = "/section/" + props.index;
  } else {
    section = "/closeSection";
  }
  // Убираем проверку progres === 100, так как пройденные модули должны быть доступны

  let goldImg = "mainPage_lessonWisdom_Pad-Item-header-currency-ico img";
  if (props.gold === true) {
    goldImg = goldImg + " icoGold";
  }

  let pearlImg = "mainPage_lessonWisdom_Pad-Item-header-currency-ico img";
  if (props.pearl === true) {
    pearlImg = pearlImg + " icoPearl";
  }

  const onclknav = () => {
    if (!props.preivSection) {
      nav(section);
    } else {
      document.querySelector(".mainPage_habit_dayPad a")?.scrollIntoView({behavior: "smooth", inline: "start"})
    }
  };

  return (
    <div onClick={onclknav} className="mainPage_lessonWisdom_Pad-Link">
      <div className={mainClass}>
        <div className="mainPage_lessonWisdom_Pad-Item-header">
          <span className="mainPage_lessonWisdom_Pad-Item-header-LessonNumber">
            {props.index < 10 ? "0" + props.index : props.index}
          </span>
          <div className="mainPage_lessonWisdom_Pad-Item-header-currency flex flex-row">
            {/* <div className="mainPage_lessonWisdom_Pad-Item-header-currency-ico icoSilver img"></div> */}
            <div className={goldImg}></div>
            <div className={pearlImg}></div>
          </div>
        </div>
        <div className="mainPage_lessonWisdom_Pad-Item-content flex">
          <span className="mainPage_lessonWisdom_Pad-Item-content-text">
            {props.title}
          </span>
        </div>
        <div className="mainPage_lessonWisdom_Pad-Item-footer flex flex-row">
          <span className="mainPage_lessonWisdom_Pad-Item-footer-text">
            {props.step}
          </span>
          <div className="mainPage_lessonWisdom_Pad-Item-footer-progressBar flex">
            {!props.lockedSection ? (
              <div className="progressBar_lessonLocked"></div>
            ) : props.totalLesson > props.complitedLesson ? (
              <div className="progressBar_lesson">
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 35 35"
                  className="circular-progress"
                  style={{ "--progress": progres } as React.CSSProperties}
                >
                  <circle className="bg"></circle>
                  <circle className="fg"></circle>
                  <defs>
                    <linearGradient
                      id="gradient"
                      x1="0%"
                      y1="0%"
                      x2="100%"
                      y2="0%"
                    >
                      <stop offset="0%" stopColor="#cd90ef"></stop>
                      <stop offset="100%" stopColor="#25bdd9"></stop>
                    </linearGradient>
                  </defs>
                </svg>
                <div
                  className="progressBar_lessonCaunt"
                  style={
                    {
                      "--complit": `${props.complitedLesson}`,
                      "--total": `${props.totalLesson}`,
                    } as React.CSSProperties
                  }
                ></div>
              </div>
            ) : (
              <div className="progressBar_lessonCheck"></div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
